// @ts-nocheck

import psHttp from '@patsnap/common-ps-http';

const workspaceApiUrlPrefix = `${process.env.VUE_APP_WORKSPACE_SERVICE_URI}/workspace/web`;
// #region  zyh
/**
 * 工作空间加密:获取公钥接口
 */
export function getPublicKeyApi() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption/public-key`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 工作空间加密:工作空间加密接口
 */
export function decodeAndEncryptionApi({ encryption_id, encryption_password, encryption_type = 'space', prompt }, type) {
    if (type === 'encrypt') {
        return postWorkspaceEncryptionApi({ encryption_id, encryption_password, encryption_type, prompt });
    }
    return postWorkspaceDecodeApi({ encryption_id, encryption_password, encryption_type });
}
export function postWorkspaceEncryptionApi({ encryption_id, encryption_password, encryption_type = 'space', prompt }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption`,
        method: 'POST',
        data: {
            encryption_id,
            encryption_password,
            encryption_type,
            prompt,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 工作空间解密:解密接口，获取token
 */
export function postWorkspaceEncryptionTokenApi({ encryption_id, encryption_password, encryption_type = 'space' }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption/token`,
        method: 'POST',
        data: {
            encryption_id,
            encryption_password,
            encryption_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 工作空间加密:工作空间取消密码
 */
export function postWorkspaceDecodeApi({ encryption_id, encryption_password, encryption_type = 'space' }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/lab/encryption`,
        method: 'DELETE',
        data: {
            encryption_id,
            encryption_password,
            encryption_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
// #endregion

/**
 * 获取workspace
 *
 * @param {String} type 类型，【自己的(self)，分享的(shared), 所有的(all)】
 */
export function getWorkspacesByTypeApi(type = 'self', { sort_type, has_share_permission, label_id, search_name } = {}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space`,
        method: 'GET',
        params: {
            type,
            sort_type,
            label_id,
            search_name,
            has_share_permission,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 创建workspace
 *
 * @param {Object} param 参数
 * @param {string} param.space_name 工作空间名称
 * @param {string} param.space_desc 工作空间描述
 * @param {string} param.space_icon 图标
 * @param {string} param.space_s3_key s3的key
 * @param {string} param.space_id 工作空间id
 * @param {string} param.public_workspace 是否是公共空间
 * @param {Boolean} init_folder 初始化folder
 */
export function createWorkspaceApi({ space_name, space_desc, space_icon, space_s3_key, space_id, public_workspace, department_permission_settings, label_ids = [] }, init_folder = true) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space`,
        method: 'POST',
        data: {
            space_name,
            space_desc,
            space_icon,
            space_s3_key,
            space_id,
            public_workspace,
            department_permission_settings,
            label_ids,
        },
        params: {
            init_folder,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 为别人创建workspace
 *
 * @param {Object} param 参数
 * @param {string} param.space_name 工作空间名称
 * @param {string} param.space_desc 工作空间描述
 * @param {string} param.space_icon 图标
 * @param {string} param.space_s3_key s3的key
 * @param {string} param.space_id 工作空间id
 * @param {string} param.owner_email 为某人创建
 * @param {Boolean} init_folder 初始化folder
 */
export function createWorkspaceForOtherApi(
    { space_name, space_desc, space_icon, space_s3_key, space_id, owner_email },
    init_folder = true
) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space-for-other`,
        method: 'POST',
        data: {
            space_name,
            space_desc,
            space_icon,
            space_s3_key,
            owner_email,
            space_id,
        },
        params: {
            init_folder,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 更新workspace
 *
 * @param {Object} param 参数
 * @param {string} param.space_name 工作空间名称
 * @param {string} param.space_desc 工作空间描述
 * @param {string} param.space_icon 图标
 * @param {string} param.space_s3_key s3的key
 * @param {string} param.space_id 工作空间id
 */
export function editWorkspaceApi({ space_name, space_desc, space_icon, space_s3_key, space_id, label_ids = [] }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}`,
        method: 'PUT',
        data: {
            space_name,
            space_desc,
            space_icon,
            space_s3_key,
            label_ids,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 删除自己的workspace
 * @param {string} space_id 工作空间id
 */
export function deleteWorkspaceApi(space_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 批量删除workspace
 */
export function batchDeleteWorkspaceApi(space_ids) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/batch-delete`,
        method: 'DELETE',
        data: space_ids,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 删除分享的workspace
 * @param {string} space_id 工作空间id
 */
export function rejectShareWorkspaceApi(space_id) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/reject-share`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 批量删除分享的workspace
 */
export function batchRejectShareWorkspaceApi(space_ids) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/batch-reject-share`,
        method: 'DELETE',
        data: space_ids,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 批量删除分享的workspace
 */
export function previewWorkspaceApi(spaceId) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${spaceId}/preview`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 上传workspace图标
 * @param {Object} param 参数
 * @param {string} param.poster 图片文件Base64
 */
export function uploadWorkspaceIconApi({ poster }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space-icon`,
        method: 'POST',
        data: { poster },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 分享workspace
 * @param {*} param0
 */
export function shareWorkspaceApi({ space_id, lang, share_permissions, delete_emails }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/share`,
        method: 'PUT',
        transformCode: true,
        data: {
            lang,
            share_permissions,
            delete_emails,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 分享多个workspace
 */
export function shareMultiWorkspacesApi({
    add_permissions,
    update_permissions,
    delete_user_ids,
    share_spaces,
    space_id,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/multi-share`,
        method: 'POST',
        transformCode: true,
        data: {
            add_permissions,
            update_permissions,
            delete_user_ids,
            share_spaces,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取当前分享过的用户邮箱地址
 * @param {*} param0
 */
export function getSharedUsersApi({ space_id }) {
    return psHttp({
        cache: false,
        url: `${workspaceApiUrlPrefix}/${space_id}/share-users`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 获取可分享的所有公司邮箱地址
 * @param {*} param0
 */
export function getSharedCompanyEmailApi({ cache } = { cache: false }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/company-email`,
        method: 'GET',
        transformCode: true,
        cache,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getSuggestionEmailApi({
    page = 0,
    limit = 20,
    name,
    cache = false,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/email/think`,
        method: 'GET',
        params: {
            page,
            limit,
            name,
        },
        transformCode: true,
        cache,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function checkWorkspaceRoleApi({ email, type, identifier, cache = false }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/email/check-workspace-role`,
        method: 'GET',
        params: { email, type },
        transformCode: true,
        identifier,
        cache,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 更新workspace访问时间
 * @param {string} param.space_id 工作空间标识
 */
export function accessTsWorkspaceApi({ space_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/access`,
        method: 'POST',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取workspace设置
 * @param {string} param.space_id 工作空间标识
 */
export function getWorkspaceSettingApi({ space_id }, params = {}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/setting`,
        method: 'GET',
        params,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 更新workspace设置
 * @param {string} param.space_id 工作空间标识
 *  * @param {string} param.collapse 结果显示选项
 *  * @param {string} param.display_charts 分析概览图表显示设置
 *  * @param {string} param.display_fields 字段显示设置
 *  * @param {string} param.family_country 专利族标签
 *  * @param {string} param.rows 每页数量
 *  * @param {string} param.sort 排序方式
 *  * @param {string} param.stem 即将废弃
 */
export function updateWorkspaceSettingApi({
    space_id,
    collapse,
    display_charts,
    display_fields,
    family_country,
    family_tag,
    rows,
    sort,
    paper_sort,
    vc_sort,
    mr_sort,
    ma_sort,
    stem,
}, params = {}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/setting`,
        method: 'PUT',
        data: {
            collapse,
            display_charts,
            display_fields,
            family_country,
            family_tag,
            rows,
            sort,
            paper_sort,
            vc_sort,
            mr_sort,
            ma_sort,
            stem,
        },
        params,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取workspace过滤左侧字段排序
 * @param {string} param.space_id 工作空间标识
 */
export function getSpaceFilterSortApi({ space_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/filter-sort`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 保存workspace过滤左侧字段排序
 */
export function saveSpaceFilterSortApi({ space_id, filter_items = [] }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/filter-sort`,
        method: 'POST',
        data: filter_items,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取workspace默认过滤左侧字段排序
 */
export function getSpaceDefaultFilterSortApi() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/default-filter-sort`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取工作空间下拉列表
 */
export function getWorkspaceSelfShareApi({ need_share_space, skip_count, patent_read_only, need_public_space = true, owner_public_space = true, current_space_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/self-share`,
        method: 'GET',
        params: { need_share_space, need_public_space, skip_count, patent_read_only, owner_public_space, current_space_id },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 查询folder
 */
export function searchWorkspaceSelfShareApi({
    need_share_space,
    skip_count,
    patent_read_only,
    folder_search_name,
    need_public_space = true,
    owner_public_space,
    data_type,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/self-share-search`,
        method: 'GET',
        params: { need_share_space, skip_count, patent_read_only, folder_search_name, need_public_space, owner_public_space, data_type },
        transformCode: true,
        headers: {
            'X-Api-Version': '2.0',
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 查询public space folder
 */
export function searchPublicWorkspaceApi() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/public-space-search`,
        method: 'GET',
        transformCode: true,
        headers: {
            'X-Api-Version': '2.0',
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取单个workspace信息
 */
export function getWorkspacesByIdApi({ space_id }) {
    return psHttp({
        uuid: `getWorkspacesByIdApi_${space_id}`,
        cache: false,
        url: `${workspaceApiUrlPrefix}/space/${space_id}`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 设置行高
 */
export function setRowHeightSettingApi({ setting = 'auto' }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/row-height-setting`,
        method: 'PUT',
        params: { setting },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function transferAdminListApi(spaceId) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/tenant/space/${spaceId}/administrator/list`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function transferPublicAuthApi(spaceId, user_ids) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/tenant/space/${spaceId}/manage/authority`,
        method: 'PUT',
        transformCode: true,
        data: {
            user_ids,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function clearTransferNotificationApi(type, spaces) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/deliver/notification`,
        method: 'POST',
        data: {
            space_ids: spaces,
            type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function transferWorkspaceApi({ dstEmail, need_comment, need_email_alert, need_field, spaces, to_company_space }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/transfer`,
        method: 'POST',
        params: {},
        data: {
            dst_email: dstEmail,
            need_comment,
            need_email_alert,
            need_field,
            spaces,
            to_company_space,
            type: 'transfer',
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getWorkspaceLabel() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}

export function createWorkspaceLabel(labelName) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label`,
        method: 'POST',
        params: {},
        data: labelName,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function updateWorkspaceLabel({ label_id, label_name }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label/${label_id}`,
        method: 'PUT',
        params: {},
        data: {
            label_name,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function deleteWorkspaceLabel(labelId) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label/${labelId}`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getWorkspaceLabelStatistics({ search_name }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/workspace/label/statistics`,
        method: 'GET',
        params: { search_name },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 获取清理脏数据提示flag
*/
export function getCleanDeletedGuide() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patents/show-clean-deleted-guide`,
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || false;
    });
}

/**
 * 设置清理脏数据提示flag
 */
export function putCleanDeletedGuide({ clean = false }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patents/clean-deleted`,
        method: 'PUT',
        params: { clean },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取所有的工作空间
 */
export function getAllWorkspace({
    need_share_space,
    need_public_space,
    folder_search_name,
    data_type,
    operate_type = 'ADD',
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/self-share-public`,
        method: 'POST',
        data: {
            need_share_space,
            need_public_space,
            folder_search_name,
            data_type,
            operate_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取搜索Workspace结果
 */
export function getSearchWorkspaceResult({ convert_query_type, folder_search_name }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/query/self-or-public`,
        method: 'POST',
        data: {
            convert_query_type,
            folder_search_name,
        },
        transformCode: true,
        headers: {
            'X-Api-Version': '2.0',
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取搜索文件结果
 */
export function getSearchFolderResult({ space_id, folder_search_name, just_check_read_patent_permit = true }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/search-folder`,
        method: 'POST',
        data: {
            space_id,
            folder_search_name,
        },
        params: {
            just_check_read_patent_permit,
        },
        transformCode: true,
        headers: {
            'X-Api-Version': '2.0',
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取自定义字段列表
 */
export function getWsCustomField(params = {}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field`,
        method: 'GET',
        params,
        transformCode: true,
        headers: {
            'X-Api-Version': '2.0',
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取自定义字段详情
 */
export function getWsCustomFieldDetail(field_id, params = { need_count: false }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/field/${field_id}`,
        method: 'GET',
        transformCode: true,
        params,
        headers: {
            'X-Api-Version': '2.0',
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
